module.exports = __webpack_public_path__ + "img/car-9.330fb591.jpg";